import * as React from 'react';
import { Flex } from '../../CommonUI/Layout';
import { StyleSheet, css } from 'aphrodite';
import { Text } from 'ilenia';

interface GeneralListProps {
    title: any;
    description?: string;
}

export const GeneralList: React.SFC<GeneralListProps> = (props) => {
    const { title, description, children } = props;
    return (
        <div className={css(styles.list)}>
            <Flex flexDirection="column">
                <div className={css(styles.header)}>
                    <div className={css(styles.title)}>
                        <Text id={title} />
                    </div>
                    {description
                        ? <div className={css(styles.description)}>
                            <Text id={description} />
                        </div>
                        : null
                    }
                </div>
                {children}
            </Flex>
        </div>
    );
};

const styles = StyleSheet.create({
    list: {
        margin: '0px auto',
        width: '100%',
        maxWidth: '760px',
        paddingBottom: '30px',
    },
    header: {
        margin: '16px',
    },
    title: {
        fontSize: '24px',
        fontWeight: 'bold',
        margin: '16px',
    },
    description: {
        fontSize: '16px',
        margin: '0px 16px 16px 16px',
        letterSpacing: '0px',
        lineHeight: '23px',
        color: '#292929',
    }
});
